import React from "react";
import { Link } from "react-router-dom";
import { IMAGES } from "../lib/site";

export default function About() {
  return (
    <div data-testid="about-page" className="pt-32">
      <section className="max-w-[1440px] mx-auto px-6 md:px-12 py-16 md:py-24 grid md:grid-cols-2 gap-16 items-center">
        <div>
          <div className="text-[11px] uppercase tracking-luxe text-gold mb-6">Our Story</div>
          <h1 className="font-serif text-5xl md:text-7xl leading-[0.95]">A crown, <span className="italic">earned.</span></h1>
          <div className="gold-divider my-8" />
          <p className="text-lg text-matte/80 leading-relaxed font-light">
            Crowned Essence was born from a simple belief: Black-owned excellence deserves to be celebrated with the reverence of a luxury routine. Not tucked away. Not overlooked. Elevated.
          </p>
          <p className="mt-5 text-base text-matte/70 leading-relaxed">
            We curate premium subscription boxes that make discovering exceptional Black-owned brands effortless — while helping those businesses grow. Every product is chosen with intention. Every unboxing is a moment.
          </p>
          <p className="mt-5 text-base text-matte/70 leading-relaxed">
            Because self-care shouldn't feel transactional. It should feel like being crowned.
          </p>
        </div>
        <div className="relative aspect-[4/5] overflow-hidden">
          <img src={IMAGES.mission} alt="About" className="absolute inset-0 w-full h-full object-cover" />
        </div>
      </section>

      <section className="bg-cream py-24 md:py-32">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12 grid md:grid-cols-3 gap-12">
          {[
            { t: "Curated with Purpose", d: "Every brand in the box is intentionally selected — for craft, integrity, and Black-owned excellence." },
            { t: "Community-First", d: "We exist to grow the brands we feature. Our success is measured by theirs." },
            { t: "Timelessly Luxurious", d: "No trends. Only routines worthy of your table, your shelf, your crown." },
          ].map(v => (
            <div key={v.t} data-testid={`value-${v.t.toLowerCase().replace(/\s+/g,'-')}`}>
              <div className="text-[10px] uppercase tracking-luxe text-gold">Value</div>
              <h3 className="font-serif text-3xl mt-3">{v.t}</h3>
              <div className="gold-divider my-5" />
              <p className="text-matte/70 leading-relaxed">{v.d}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="py-24 md:py-32 text-center">
        <div className="max-w-3xl mx-auto px-6">
          <h2 className="font-serif text-4xl md:text-6xl leading-[1.05]">Ready to join the crown?</h2>
          <div className="mt-10 flex flex-wrap justify-center gap-4">
            <Link data-testid="about-cta-waitlist" to="/waitlist" className="px-10 py-4 bg-matte text-gold border border-gold/40 text-[11px] uppercase tracking-luxe-sm hover:bg-black transition-colors">Join the Waitlist</Link>
            <Link data-testid="about-cta-partner" to="/partnerships" className="px-10 py-4 border border-matte text-matte text-[11px] uppercase tracking-luxe-sm hover:bg-matte/5 transition-colors">Partner With Us</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
